import { Component, Prop, h, State, Element } from '@stencil/core';

@Component({
  tag: 'dda-sticky-footer',
  styleUrls: ['dda-sticky-footer.css', '../../global/global.css'],
  shadow: false,
})
export class DdaStickyFooter {
  @Element() el: HTMLElement;

  @Prop() happinessIconHref?: string;
  @Prop() happinessIconId?: string;
  @Prop() happinessIconSrc: string;
  @Prop() happinessIconAlt: string;
  @Prop() happinessIconTooltip: string;

  @Prop() accessibilityIconHref: string;
  @Prop() accessibilityIconId: string;
  @Prop() accessibilityIconSrc: string;
  @Prop() accessibilityIconAlt: string;
  @Prop() accessibilityIconTooltip: string;

  @Prop() servicesIconHref: string;
  @Prop() servicesIconId: string;
  @Prop() servicesIconSrc: string;
  @Prop() servicesIconAlt: string;
  @Prop() servicesIconTooltip: string;
  @Prop() servicesIconText: string;

  @Prop() hideMiddleSection: boolean = false;
  @Prop() middleLink: string;
  @Prop() rightLink: string;

  @Prop() aiIconHref: string;
  @Prop() aiIconId: string;
  @Prop() aiIconSrc: string;
  @Prop() aiIconAlt: string;
  @Prop() aiIconTooltip: string;

  @Prop() dubaiaeIconHref: string;
  @Prop() dubaiaeIconId: string;
  @Prop() dubaiaeIconSrc: string;
  @Prop() dubaiaeIconSmallSrc: string;
  @Prop() dubaiaeIconAlt: string;
  @Prop() dubaiaeIconTooltip: string;

  @Prop() chatIconHref: string;
  @Prop() chatIconId: string;
  @Prop() chatIconSrc: string;
  @Prop() chatIconAlt: string;
  @Prop() chatIconTooltip: string;
  @Prop() moreIcon: string;

  @State() isHidden: boolean = false;
  private lastScrollY: number = 0;

  componentWillLoad() {
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidLoad() {
    window.addEventListener('scroll', this.handleScroll);
    const toggleBtn = this.el.shadowRoot.querySelector('.show-right-icon') as HTMLElement;
    const iconList = this.el.shadowRoot.querySelector('.foot-right_links') as HTMLElement;
    const items = iconList?.querySelectorAll('li') || [];
    if (toggleBtn && iconList) {
      toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const isShown = iconList.classList.contains('show-dda-icon');

        if (!isShown) {
          iconList.classList.add('show-dda-icon');
          items.forEach((item, index) => {
            (item as HTMLElement).style.transitionDelay = `${index * 100}ms`;
          });
        } else {
          items.forEach((item) => {
            (item as HTMLElement).style.transitionDelay = '0ms';
          });
          iconList.classList.remove('show-dda-icon');
        }
      });
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const currentScrollY = window.scrollY;
    this.isHidden = currentScrollY > this.lastScrollY;
    this.lastScrollY = currentScrollY;
  }

  private parseJsonArray(jsonString: string) {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      console.error('Failed to parse JSON:', e);
      return [];
    }
  }

  chatIconClick() {
    console.log("chat icon click")
  }

  aiIconClick() {
    console.log("ai icon click")
  }

  dubaiAEClick() {
    console.log('dubai.ae icon click')
  }

  rightItemClick(item) {
    console.log('right item clicked:', item);
  }

  render() {
    const footmiddlesection = this.parseJsonArray(this.middleLink);
    const footrightsection = this.parseJsonArray(this.rightLink);

    return (
      <footer class={{ 'dda-footer': true, 'hidden': this.isHidden }}>
        <div class="footer-content">
          <div class="dda-footer-item dda-footer-left">
            <ul>
              {this.happinessIconSrc && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.happinessIconTooltip} description="" position="top">
                    <a href={this.happinessIconHref} id={this.happinessIconId}>
                      <img src={this.happinessIconSrc} alt={this.happinessIconAlt} />
                    </a>
                  </dda-tooltip>
                </li>
              )}

              {this.accessibilityIconSrc && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.accessibilityIconTooltip} description="" position="top">
                    <a href={this.accessibilityIconHref} id={this.accessibilityIconId}>
                      <img src={this.accessibilityIconSrc} alt={this.accessibilityIconAlt} />
                    </a>
                  </dda-tooltip>
                </li>
              )}

              {this.servicesIconText && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.servicesIconTooltip} description="" position="top">
                    <a href={this.servicesIconHref} id={this.servicesIconId}>
                      <img src={this.servicesIconSrc} alt={this.servicesIconAlt} />
                      <span>{this.servicesIconText}</span>
                    </a>
                  </dda-tooltip>
                </li>
              )}
            </ul>
          </div>

          {!this.hideMiddleSection && (
            <div class="dda-footer-item dda-footer-middle">
              <ul class="foot-logo">
                {footmiddlesection.map((middleItem, index) => (
                  <li key={index}>
                    <dda-tooltip title_text={middleItem.LogoTooltip} description="" position="top">
                      <a href={middleItem.href}>
                        <img src={middleItem.src} alt={middleItem.alt} />
                      </a>
                    </dda-tooltip>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div class="dda-footer-item dda-footer-right">
            <ul class="foot-right_links">
              {footrightsection.map((rightItem, index) => (
                <li class="foot-icon-btn" key={index}>
                  <dda-tooltip title_text={rightItem.RightLinkTooltip} description="" position="top">
                    <a href={rightItem.href} title={rightItem.title} aria-label={rightItem.ariaLabel} id={rightItem.itemId} onClick={() => this.rightItemClick(rightItem)}>
                      <i class={rightItem.IconFamily}>{rightItem.IconName}</i>
                      <span>{rightItem.LinkText}</span>
                    </a>
                  </dda-tooltip>
                </li>
              ))}

              {this.dubaiaeIconSrc && this.dubaiaeIconSmallSrc && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.dubaiaeIconTooltip} description="" position="top">
                    <a href={this.dubaiaeIconHref} onClick={this.dubaiAEClick} id={this.dubaiaeIconId}>
                      <img class="dubaiae-text-icon" src={this.dubaiaeIconSrc} alt={this.dubaiaeIconAlt} />
                      <img class="dubaiae-small-icon" src={this.dubaiaeIconSmallSrc} alt={this.dubaiaeIconAlt} />
                    </a>
                  </dda-tooltip>
                </li>
              )}

              {this.aiIconSrc && (
                <li class="foot-icon-btn">
                  <dda-tooltip title_text={this.aiIconTooltip} description="" position="top">
                    <a href={this.aiIconHref} onClick={this.aiIconClick} id={this.aiIconId}>
                      <img src={this.aiIconSrc} alt={this.aiIconAlt} />
                    </a>
                  </dda-tooltip>
                </li>
              )}

              <li class="foot-icon-btn">
                <dda-tooltip title_text={this.chatIconTooltip} description="" position="top">
                  <a href={this.chatIconHref} onClick={this.chatIconClick} id={this.chatIconId}>
                    <img src={this.chatIconSrc} alt={this.chatIconAlt} />
                  </a>
                </dda-tooltip>
              </li>
            </ul>
            <button type="button" class="show-right-icon">
              <i class="material-icons">{this.moreIcon}</i>
            </button>
          </div>
        </div>
      </footer>
    );
  }
}
